module.exports = __webpack_public_path__ + "img/ic_140_achievement_spieltagssieg.f792b8b7.svg";